/**
 * Remove do ID da cobrança prefixos vindos de template bugado do WhatsApp (ex. {{1}}, {{1}}link).
 * URLs como .../checkout/%7B%7B1%7D%7D38496cad-... ou .../checkout/{{1}}38496cad-... passam a
 * usar só o UUID: 38496cad-...
 */
const UUID_REGEX =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

/** Prefixos de placeholder do template WhatsApp (após decode: {{1}}, {{1}}link) */
const PLACEHOLDER_PREFIXES = /^(\{\{1\}\}link?|\{\{1\}\})/i;

/**
 * Retorna o ID da cobrança limpo (sem prefixo de placeholder do WhatsApp).
 * Se o valor já for um UUID ou não tiver prefixo conhecido, devolve como está.
 */
export function cleanCheckoutChargeId(raw: string | undefined): string {
  if (!raw || typeof raw !== 'string') return raw ?? '';
  let value = raw.trim();
  if (!value) return '';

  try {
    value = decodeURIComponent(value);
  } catch {
    // mantém o valor se falhar o decode
  }

  // Extrai UUID no valor (ex.: {{1}}38496cad-43f8-454d-a42a-54ffa105969c)
  const uuidMatch = value.match(UUID_REGEX);
  if (uuidMatch) return uuidMatch[0];

  // Remove prefixo conhecido e usa o restante
  const withoutPrefix = value.replace(PLACEHOLDER_PREFIXES, '').trim();
  return withoutPrefix || value;
}
